/**
 * Whether the page URL names the route's departure — `?from=<slug>`, or a
 * curated journey path `/<locale>/routes/<from>-to-<to>`. Such a link pins
 * its `from`: the launch geolocation snap (camera + `from` = nearest
 * station) is for an unpinned start only (owner 2026-10-19: reloading
 * `/en-GB/route?to=green-park&from=cadogan` replaced Cadogan with the
 * user's nearest station). Read from `window.location`, like
 * `readInitialViewOverride`, at launch.
 */
export function urlNamesRouteDeparture(): boolean {
  /* v8 ignore next — SSR guard; metro-frontend is CSR-only (Vite SPA). */
  if (typeof window === 'undefined') return false
  const from = new URLSearchParams(window.location.search).get('from')
  if (from !== null && from.length > 0) return true
  return /\/routes\/[^/]+-to-[^/]+\/?$/.test(window.location.pathname)
}
